import Table from "../../../Components/Table/Table";
import SVG from "../../../Components/SVG";
import Custom from "../../../Components/Buttons/Custom";
import TableButton from "../../../Components/Buttons/TableButton";
import { formatTradePrice } from "../../../helper/formatTradePrice";
import { toJalaliDateTime } from "../../../helper/toJalaliDateTime";
export default function TradeHistory({ accountData }) {
  return (
    <div className="w-full p-5 flex flex-col gap-5 rounded-2xl bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <div className="flex justify-between items-center">
        <h3 className="flex gap-2.5 items-center">
          <SVG
            name="archive"
            classname="size-5 stroke-zi-text-light dark:stroke-zi-text-dark"
          />
          <p className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
            تاریخچه معاملات
          </p>
        </h3>
        <Custom
          text="دانلود CSV"
          className="bg-zi-gradient-button-blue !px-5 !py-2 !rounded-full text-zi-text-dark hocus:ring-1 hocus:ring-offset-1 hocus:ring-zi-border-dark"
        />
      </div>

      {accountData && accountData.trades && accountData.trades.length > 0 ? (
        <Table
          isLTR={true}
          columns={[
            { key: "uuid", label: "کد معامله" },
            { key: "openTime", label: "زمان باز شدن" },
            { key: "openPrice", label: "قیمت باز شدن" },
            { key: "closeTime", label: "زمان بسته شدن" },
            { key: "closePrice", label: "قیمت بسته شدن" },
            { key: "pnl", label: "سود" },
            { key: "volume", label: "حجم" },
            { key: "commission", label: "کمیسیون" },
            { key: "netPNL", label: "سود خالص" },
            { key: "symbol", label: "نماد" },
            { key: "tradeType", label: "نوع معامله" },
            // {
            //   key: "detail",
            //   label: "جزئیات",
            //   render: (value) => (
            //     <TableButton
            //       text="مشاهده"
            //       href=""
            //       className="!py-1 !px-2 !rounded-md bg-zi-bg1-light dark:bg-zi-bg1-dark text-zi-text-light dark:text-zi-text-dark hocus:ring-1 hocus:ring-inset hocus:ring-zi-border-dark"
            //     />
            //   ),
            // },
          ]}
          data={accountData.trades.map((trade) => ({
            uuid: trade.id,
            openTime: toJalaliDateTime(trade.opened_at),
            openPrice: formatTradePrice(trade.entry_price),
            closeTime: toJalaliDateTime(trade.closed_at),
            closePrice: formatTradePrice(trade.exit_price),
            pnl:
              Number(trade.profit_loss) >= 0
                ? `$${Number(
                    Number(trade.profit_loss).toFixed(2),
                  ).toLocaleString()}`
                : `-$${Number(
                    Number(trade.profit_loss.replace(/^-/, "")).toFixed(2),
                  ).toLocaleString()}`,
            volume: Number(
              Number(trade.margin_usdt).toFixed(2),
            ).toLocaleString(),
            commission: "$0",
            netPNL:
              Number(trade.profit_loss) >= 0
                ? `$${Number(
                    Number(trade.profit_loss).toFixed(2),
                  ).toLocaleString()}`
                : `-$${Number(
                    Number(trade.profit_loss.replace(/^-/, "")).toFixed(2),
                  ).toLocaleString()}`,
            symbol: trade.symbol.toUpperCase(),
            tradeType: trade.side === "long" ? "Buy" : "Sell",
            detail: "",
          }))}
        />
      ) : (
        <Table
          isLTR={true}
          columns={[
            { key: "uuid", label: "کد معامله" },
            { key: "openTime", label: "زمان باز شدن" },
            { key: "openPrice", label: "قیمت باز شدن" },
            { key: "closeTime", label: "زمان بسته شدن" },
            { key: "closePrice", label: "قیمت بسته شدن" },
            { key: "pnl", label: "سود" },
            { key: "volume", label: "حجم" },
            { key: "commission", label: "کمیسیون" },
            { key: "netPNL", label: "سود خالص" },
            { key: "symbol", label: "نماد" },
            { key: "tradeType", label: "نوع معامله" },
            // {
            //   key: "detail",
            //   label: "جزئیات",
            //   render: (value) => (
            //     <TableButton
            //       text="مشاهده"
            //       href=""
            //       className="!py-1 !px-2 !rounded-md bg-zi-bg1-light dark:bg-zi-bg1-dark text-zi-text-light dark:text-zi-text-dark hocus:ring-1 hocus:ring-inset hocus:ring-zi-border-dark"
            //     />
            //   ),
            // },
          ]}
          data={[]}
        />
      )}
    </div>
  );
}
